<template>
  <!-- v-loading='loading' -->
  <div class="advancedSearch_head adshdMd">
    <el-tabs class="advanced-search-tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane class="fx-c fx-c-hy" label="行业模板">
        <el-input class="fx-none tab-pane-inner0" placeholder="请输入模板名称" v-model="searchValue1" size="small" @input="searchTemplate" @focus="inputFocus" @blur="inputBlur">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-scrollbar style="height:100%;">
          <div class="fx-full tab-pane-inner1" v-if="isSearch">
            <div v-for="(child,index) in searchList" :key="index" class="childItem" :class="{'selected':child.selected}" @click="selectTemplate(child,templateList1)">
              <!-- <div class="mark mark-1 fx-none"><i class="iconfont icon-markzhuanhuan"></i></div> -->
              <div class="mark mark-1 fx-none"><img src="@/assets/gbIcon/adbig.svg" alt=""></div>
              <div class="fx-full" style="height: auto;">
                <div class="title">{{child.category}}</div>
                <div class="sub-title">{{child.templateName}}</div>
              </div>
            </div>
            <div class="emptyBox" v-if="!searchList.length">
              <!-- <img src="@/assets/emptyBox.svg" width="200" alt="" srcset=""> -->
              <img src="@/assets/empty.png" width="150" alt="" srcset="">
              <p class="center">暂无数据</p>
            </div>
          </div>
          <el-collapse v-else class="fx-full tab-pane-inner1" v-model="collapseNames" @change="handleChange">
            <el-collapse-item :name="index" v-for="(item,index) in templateList1" :key="index">
              <template slot="title">
                <i class="header-icon el-icon-caret-right"></i>{{item.category}}（{{item.templates.length}}）
              </template>
              <div v-for="(child,index) in item.templates" :key="index" class="childItem" :class="{'selected':child.selected}" @click="selectTemplate(child,templateList1)">
                <!-- <div class="mark mark-1 fx-none"><i class="iconfont icon-markzhuanhuan"></i></div> -->
                <div class="mark mark-1 fx-none"><img src="@/assets/gbIcon/adbig.svg" alt=""></div>
                <div class="fx-full" style="height: auto;">
                  <div class="title">{{child.category}}</div>
                  <div class="sub-title">{{child.templateName}}</div>
                </div>
              </div>
              <div class="emptyBox" v-if="!item.templates.length">
                <img src="@/assets/empty.png" width="150" alt="" srcset="">
                <p class="center">暂无数据</p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
      </el-tab-pane>
      <el-tab-pane class="fx-c fx-c-zdy" label="自定义模板">
        <el-input class="fx-none tab-pane-inner0" placeholder="请输入模板名称" v-model="searchValue2" size="small" @input="searchTemplate2">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-scrollbar style="height:100%;">
          <!-- <div class="fx-full tab-pane-inner1 scrollbar scrollbar-y" v-if="isSearch"> -->
          <div class="fx-full tab-pane-inner1" v-if="isSearch">
            <div v-for="(child,index) in searchList" :key="index" class="childItem" :class="{'selected':child.selected}" @click="selectTemplate(child,templateList2)">
              <!-- <div class="mark fx-none"><i class="iconfont icon-markzhuanhuan"></i></div> -->
              <div class="mark mark-1 fx-none"><img src="@/assets/gbIcon/adbig.svg" alt=""></div>
              <div class="fx-full" style="height: auto;">
                <div class="sub-title">{{child.templateName}}</div>
              </div>
            </div>
            <div class="emptyBox" v-if="!searchList.length">
              <img src="@/assets/empty.png" width="150" alt="" srcset="">
              <p class="center">暂无数据</p>
            </div>
          </div>
          <!-- <div v-else class="fx-full tab-pane-inner1 scrollbar scrollbar-y"> -->
          <div v-else class="fx-full tab-pane-inner1">
            <div v-for="(child,index) in templateList2" :key="index" class="childItem" :class="{'selected':child.selected}" @click="selectTemplate(child,templateList2)">
              <!-- <div class="mark fx-none"><i class="iconfont icon-markzhuanhuan"></i></div> -->
              <div class="mark mark-1 fx-none"><img src="@/assets/gbIcon/adbig.svg" alt=""></div>
              <div class="fx-full" style="height: auto;">
                <div class="sub-title">{{child.templateName}}</div>
              </div>
              <div class="btns btnsMd">
                <el-tooltip class="item" effect="dark" :open-delay="200" :content="'修改模板名称'" placement="top">
                  <i class="edit-icon" type="primary" size="medium" @click.stop="editName(child)"><img src="~@/assets/gbIcon/edit_icon.png"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :open-delay="200" :content="'删除'" placement="top">
                  <i type="primary" size="medium" class="el-icon-delete" @click.stop="deleteTemplate(child)"></i>
                  <!-- <el-button type="danger" size="mini" icon="el-icon-delete" @click.stop="deleteTemplate(child)" /> -->
                </el-tooltip>
              </div>
            </div>

            <div class="emptyBox" v-if="!templateList2.length">
              <img src="@/assets/empty.png" width="150" alt="" srcset="">
              <p class="center">暂无数据</p>
            </div>
          </div>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getTemplateList, saveOrUpdateTemplate, deleteTemplate, highKeywordList, testPoint } from '../api/newClueApi'
import { X_BLOCK, X_PRODUCT, X_HIDE } from '@/utils/iframeUtils'
const cacheObj = { templateList1: null, templateList2: null }
export default {
  data() {
    return {
      loading: false,
      activeName: '0',
      // 行业模板列表
      searchValue1: '',
      templateList1: [],
      collapseNames: [0],

      // 自定义模板列表
      searchValue2: '',
      templateList2: [],
      isSearch: false,
      searchList: [],
      validatorFlag: false,
      windowProductObj: { 'scrmqw': 'SCRM企微', 'scrmzy': 'SCRM专业' }
    }
  },
  mounted() {
    this.getTabData()
    this.getTabData(false, 1)

    // 获取默人条件（无保存）
    this.getNoSaveCondition()
  },
  methods: {
    getNoSaveCondition() {
      if (JSON.parse(localStorage.getItem('inputDefaultCondition'))) {
        const dataSource = JSON.parse(localStorage.getItem('inputDefaultCondition'))
        this.updateData(dataSource.conditionVos)
        this.$store.commit('setDefaultCondition', dataSource)
        this.$emit('updateSearchFilter')
      }
    },
    inputFocus(val) {
      if (this.searchValue1 || this.searchValue2) {
        this.isSearch = true
      }
    },
    inputBlur() {
      if (this.searchValue1 || this.searchValue2) {
        this.isSearch = true
      } else {
        this.isSearch = false
      }
    },

    searchTemplate(val) {
      if (!val) {
        this.isSearch = false
        this.searchList = []
        return
      }
      this.isSearch = true
      const arr = this.templateList1.map(e => e.templates)
      const arr2 = []
      arr.forEach(e => {
        e.forEach(ee => {
          arr2.push(ee)
        })
      })
      this.searchList = arr2.filter(e => e.templateName.includes(val))
    },

    searchTemplate2(val) {
      if (!val) {
        this.isSearch = false
        this.searchList = []
        return
      }
      this.isSearch = true
      this.searchList = this.templateList2.filter(e => e.templateName.includes(val))
    },
    editName(item) {
      const inputValidator = (value) => {
        if (value && value.trim() && value.trim().length <= 10) {
          let index

          // 解决的坑： .5秒内不校验自己
          if (this.validatorFlag) {
            index = this.templateList2.findIndex(e => e.templateName === value && e.templateName !== item.templateName)
          } else {
            index = this.templateList2.findIndex(e => e.templateName === value)
          }
          if (index !== -1) return '不能重复命名'
          return true
        } else {
          return '长度需为1-10位'
        }
      }

      // 解决的坑： .5秒内不校验自己
      this.validatorFlag = true
      setTimeout(() => { this.validatorFlag = false }, 5000)

      this.$prompt('请输入模板名字（名字长度为1-10个字符）', '更改名字', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator,
        inputValue: item.templateName,
        customClass: 'winClass',
      }).then(({ value }) => {
        this.saveOrUpdateTemplate(value, item)
      }).catch(() => { })
    },
    deleteTemplate({ id }) {
      this.$confirm('此操作将永久删除该模版，是否继续？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning',
        customClass: 'winClass delClass',
      }).then(() => {
        this.deleteTemplateFn(id)
      }).catch(() => { })
    },
    async deleteTemplateFn(id) {
      const { code } = await deleteTemplate({ id })
      if (code === 200) {
        this.$message.success('删除成功')
        this.getTabData(true)
      }
    },

    async saveOrUpdateTemplate(templateName, item) {
      const { code, message } = await saveOrUpdateTemplate({ ...item, templateName })
      if (code === 200) {
        this.$message.success('保存成功')
        this.getTabData(true)
      } else {
        this.$message.success(message)
      }
    },
    getTabData(refresh = false, idx = this.activeName) {
      const type = +idx + 1
      const key = `templateList${type}`

      if (!refresh) {
        if (this[key].length) {
          return
        }
        if (cacheObj[key]) {
          this[key] = JSON.parse(JSON.stringify(cacheObj[key]))
          return
        }
      }

      this.reqData(type, (resp) => {
        console.dir(resp)
        this[key] = resp
        cacheObj[key] = resp
      })
    },
    // 过滤器
    dataCleansing(options, keysArr) {
      let arr = []
      options.conditionVos.forEach(v => {
        if (!v.childOption) {
          let box = keysArr.find(v1 => v1.id == v.conditionId)
          if (box && box.inUse == 1) {
            arr.push(v)
          }
        } else {
          v.childOption = this.dataCleansing(v.childOption, keysArr)
          arr.push(v)
        }
      })

      options.conditionVos = arr

      // console.log(options, 99999)
      return options

    },
    async reqData(type, after = (resp) => { }, before = () => true) {
      this.loading = true
      if (!before()) return
      const { data } = await getTemplateList({ type })

      // 过滤禁用选项模板 ------------------ start
      try {
        const { data: keys } = await highKeywordList()
        const keysArr = keys.map(v => v.children).reduce((prev, cur) => prev.concat(cur), [])
        data.forEach(item => {
          if (item.templates) {
            item.templates.forEach(subItem => {
              if (subItem.options) {
                let options = this.dataCleansing(JSON.parse(subItem.options), keysArr)
                subItem.options = JSON.stringify(options)
              }
            })
          } else if (item.options) {
            let options = this.dataCleansing(JSON.parse(item.options), keysArr)
            item.options = JSON.stringify(options)
          }
        })
      } catch (error) {
        console.log(error)
      }
      // 过滤禁用选项模板 ------------------ end

      this.loading = false
      after(data)
    },
    handleChange(val) {

    },
    handleClick({ index }) {
      this.searchValue1 = ''
      this.searchValue2 = ''
      this.searchList = []
      this.isSearch = false
      this.getTabData(index)
    },
    async selectTemplate(item, template) {
      template.forEach(e => {
        if (e.templates) {
          e.templates.forEach(ee => {
            this.$set(ee, 'selected', false)
          })
        } else {
          this.$set(e, 'selected', false)
        }
      })
      this.$set(item, 'selected', true)
      console.log('选择模板的数据', JSON.parse(item.options))
      const dataSource = JSON.parse(item.options)
      this.updateData(dataSource.conditionVos)
      this.$store.commit('setDefaultCondition', dataSource)
      console.log('选择模板的数据 chuli', dataSource)
      this.$emit('updateSearchFilter')
      // 埋点
      if (this.activeName == 0) {
        let productName = ''
        if (window[X_PRODUCT]) {
          productName = windowProductObj[window[X_PRODUCT]]
        } else {
          if (window[X_BLOCK]) {
            productName = 'SCRM企微'
          } else {
            if (window[X_HIDE]) {
              productName = 'SCRM专业'
            } else {
              productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') ? 'ERP-臻寻客' : 'T云-臻寻客'
            }
          }
        }
        let paramsM = {
          eventType: 'template_advanced_search',//事件类型
          productName: productName,//产品线名称
          templateName: item.templateName
        }
        testPoint(paramsM).then(res => {

        }).catch(err => {

        })
      }
    },
    // 更新格式 
    updateData(dataSource) {
      const fn = (arr) => {
        arr.forEach(item => {
          if (item.childOption) {
            fn(item.childOption.conditionVos)
          } else if (item.conditionType === 4 && item.conditionValues.length === 1) {
            const arr = item.conditionValues[0].value.split(' ')
            item.conditionValues = arr.map(e => ({ label: e, value: e }))
          }
        })
      }
      fn(dataSource)
    },
  }
}
</script>
<style lang="scss"  scoped>
.advancedSearch_head {
  // border: 1px solid #f2f2f2;
  height: 100%;

  /deep/ .el-input__icon {
    // font-size: 20px;
    // color: #4f7afd;
    font-size: 16px;
    font-weight: 800;
    &.el-icon-search {
      background-image: url("~@/assets/gbIcon/search_icon.svg");
      background-repeat: no-repeat;
      background-position-y: center;
      &::before {
        content: "";
      }
    }
  }
  /deep/ .el-collapse-item__arrow {
    display: none;
  }
  /deep/ .el-collapse-item__header {
    border: none;
    color: #333333;
    font-size: 13px;
    font-weight: normal;
    height: 36px;
    line-height: 36px;
    background: none;
  }
  /deep/ .el-collapse-item__header .header-icon {
    translate: all 0.3s;
    margin-right: 6px;
  }
  /deep/ .el-collapse-item__header.is-active .header-icon {
    transform: rotate(90deg);
  }
  /deep/ .el-collapse-item__content {
    padding: 0;
    background-color: rgba(245, 246, 248, 0.49);
  }
  /deep/ .el-collapse-item__wrap {
    border: 0;
  }

  /deep/ .el-tabs__nav-wrap {
    // padding: 0 24px;
    padding: 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }
  .advanced-search-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
    // padding: 0 8px 0 24px;
    box-sizing: border-box;
  }
  .advanced-search-tabs /deep/ .el-tabs__header {
    flex-grow: 0;
    flex-shrink: 0;
    margin: 0;
    padding-left: 24px;
    box-sizing: border-box;
    padding-top: 10px;
  }
  .advanced-search-tabs /deep/ .el-tabs__content {
    flex-grow: 1;
    flex-shrink: 1;
    height: 0;
    // padding: 0;
    padding: 0 0 0 24px;
    box-sizing: border-box;
    background: rgba(245, 246, 248, 0.49);
    .el-tab-pane {
      height: 100%;
    }
  }
}

.childItem {
  cursor: pointer;
  display: flex;
  align-items: center;
  // padding: 10px 15px;
  // background: #eff4ff;
  margin-bottom: 8px;
  border-radius: 4px;
  border: 1px solid transparent;

  padding: 0px 18px 0px 16px;
  box-sizing: border-box;
  background: rgba(80, 136, 255, 0.1);
  height: 52px;
  line-height: 52px;
  &.selected,
  &:hover {
    // border: 1px solid rgb(65, 129, 255);
    border: 1px solid rgb(80, 136, 255);
  }
  .title,
  .sub-title {
    font-size: 12px;
  }
  &:hover .title,
  .sub-title {
    color: rgb(65, 129, 255);
  }
  .sub-title {
    font-weight: 400;
    color: #333333;
    font-size: 13px;
  }
  .mark {
    // margin-right: 6px;
    // color: rgb(255, 176, 37);
    margin-right: 8px;
    color: rgb(255, 160, 0);
  }
  .mark-1 {
    // transform: translateY(-3px);
    transform: translateY(-8px);
  }
}
.childItem:last-child {
  margin: 0;
}
.fx-c-zdy {
  .childItem {
    .mark-1 {
      transform: translateY(0px);
    }
    .fx-full {
      width: 110px;
      .sub-title {
        line-height: 19px;
      }
    }
    .btnsMd {
      display: none;
    }
    &:hover {
      .btnsMd {
        display: block;
      }
    }
  }
}
.tab-pane-inner0 {
  // width: calc(100% - 24px);
  width: calc(100% - 30px);
  // margin: 15px 12px;
  margin: 24px 0 16px 0;
}
.tab-pane-inner1 {
  // padding: 0 12px 12px;
  padding: 0 30px 12px 0;
  border: 0;
  box-sizing: border-box;
}
.fx {
  display: flex;
}
.fx-c {
  display: flex;
  flex-direction: column;
}
.fx-none {
  flex-grow: 0;
  flex-shrink: 0;
  &.tab-pane-inner0 {
    background: #ffffff;
  }
}
.fx > .fx-full {
  width: 0;
}
.fx-c > .fx-full {
  height: 0;
}
.fx-full {
  flex-grow: 1;
  flex-shrink: 1;
  .emptyBox {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin: 100px auto;
    position: relative;
    > img {
      width: 150px;
      // margin-bottom: 10px;
    }
    .center {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      font-size: 14px;
      color: #999999;
    }
  }
}
.btns {
  /deep/ .el-button {
    padding: 4px;
  }
}
::v-deep {
  .el-input__inner {
    border: 1px solid #e8e8f0;
    box-shadow: none;
    &:focus {
      border-color: #e8e8f0;
    }
  }
  .childItem {
    .mark {
      img {
        width: 20px;
      }
      .icon-markzhuanhuan:before {
        font-size: 20px;
      }
    }
  }
  .fx-c-hy {
    .childItem {
      height: 60px;
      line-height: 60px;
    }
  }
  .el-icon-caret-right {
    &::before {
      color: #5c6075;
    }
  }
  //  .fx-c{
  //       .el-input__inner{
  //           background: url("~@/assets/gbIcon/search_icon.png") no-repeat 204px center;
  //      }
  //  }
  .adshdMd {
    .el-tabs__item {
      height: 36px;
      line-height: 36px;
    }
  }
}
.btnsMd {
  height: 44px;
  .el-icon-edit:before,
  .el-icon-delete:before {
    font-size: 20px;
  }
  .el-icon-edit:before {
    color: #5088ff;
  }
  i:nth-of-type(1) {
    margin-right: 18px;
  }
}
.adshdMd {
  .fx-c-hy {
    .fx-full {
      line-height: normal;
    }
    .childItem .title {
      font-size: 13px;
      line-height: 18px;
    }
    .childItem .sub-title {
      font-size: 12px;
      color: #5088ff;
      padding-top: 4px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 75%;
    }
  }
  .scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.2);
    padding-left: 6px;
    box-sizing: border-box;
  }
}

.winClass {
  width: 350px;
  min-width: auto;
  border-radius: 4px;
  padding-bottom: 0 !important;
  .el-message-box__header {
    background: #fbfbfb;
    padding: 0 18px 0 24px;
    box-sizing: border-box;
    .el-message-box__title {
      height: 42px;
      line-height: 42px;
      font-weight: 600;
      color: #666666;
      font-size: 14px;
    }
    .el-message-box__headerbtn {
      top: 10px;
      .el-message-box__close,
      .el-icon-close:before {
        width: 20px;
        height: 20px;
        font-size: 20px;
      }
    }
  }
  .el-message-box__content {
    padding: 24px 24px 0;
    box-sizing: border-box;
    .el-message-box__message {
      p {
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        font-size: 14px;
      }
    }
    .el-message-box__input {
      padding-top: 8px;
      padding-bottom: 18px;
    }
  }
  .el-message-box__btns {
    text-align: center;
    height: 56px;
    line-height: 56px;
    background: #fafafa;
    padding: 0;
  }
  .el-message-box__errormsg {
    margin-top: 4px;
  }
  &.delClass {
    .el-message-box__content {
      padding-bottom: 24px;
    }
  }
}
.edit-icon {
  img {
    width: 20px;
    height: 20px;
    margin-top: -8px;
  }
}
</style>
